import { render } from "./icon-exclamation-triangle.vue?vue&type=template&id=8473b56a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__